import React                           from 'react';
import { smallestHoleSize as tooltip } from 'pu-data/Tooltips';
import TextComponent                   from './TextComponent';

const SmallestHoleSize = (props) => {
  const name = 'smallest_hole_size';
  const onChange = e => props.onChangeParameter(name, e.target.value);
  return (
    <TextComponent
      label={props.label}
      name={name}
      value={props.parameters[name] || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      groupName={props.groupName}
      className={props.className} />
  );
};

SmallestHoleSize.defaultProps = {
  tooltip,
  label: 'Smallest<br class="d-none d-lg-block" /> Hole Size',
};

export default SmallestHoleSize;
